import '../index.css';

export const slides = [

    {
      url: 'https://firebasestorage.googleapis.com/v0/b/silver-protect.appspot.com/o/imgsSilver%2Fheroimgs1.png?alt=media&token=91e9a63c-dea5-4ae2-aee7-714dc8df5525'
    },
    {
      url: 'https://firebasestorage.googleapis.com/v0/b/silver-protect.appspot.com/o/imgsSilver%2Fheroimgs2.png?alt=media&token=54ee3b9d-0412-4431-bbd1-2c9e91f75f1e'
    },
    {
      url: 'https://firebasestorage.googleapis.com/v0/b/silver-protect.appspot.com/o/imgsSilver%2Fheroimgs3.png?alt=media&token=70d096ac-bc12-4e53-b182-98d40e909aff'
    },
    {
      url: 'https://firebasestorage.googleapis.com/v0/b/silver-protect.appspot.com/o/imgsSilver%2Fheroimgs4.png?alt=media&token=f3f3fb27-0094-45d8-88a7-7c3cf1ad1c5e'
    },
    {
      url: 'https://firebasestorage.googleapis.com/v0/b/silver-protect.appspot.com/o/imgsSilver%2Fheroimgs5.png?alt=media&token=9e4bedcf-db81-4e2c-9656-268b3ef84c9a'
    },
    {
      url: 'https://firebasestorage.googleapis.com/v0/b/silver-protect.appspot.com/o/imgsSilver%2Fheroimgs6.png?alt=media&token=02bd629a-f5da-41fb-b560-ebd4ebc9fc1a'
    }


  ];

export const logo = [
    {
        id: 1,
        logo: 'https://firebasestorage.googleapis.com/v0/b/silver-protect.appspot.com/o/silver2.png?alt=media&token=2c7b110e-2612-42a8-8308-91a16ca45f4c'
    }

]